import React, { useState } from "react";
import axios from 'axios';
import { API_BASE_URL } from "../../../constant/constant";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Collapse,
  IconButton,
  Alert,
  
} from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  } from "@mui/icons-material";

function SP_Notification() {
    const [open, setOpen] = useState(true);
  const notifications = [
    { type: "error", msg: "Database connection issue detected!" },
    { type: "warning", msg: "High memory usage on server 2." },
    { type: "info", msg: "System update available." },
    { type: "success", msg: "Backup completed successfully." },
  ];
  return (
    <div>
       <Card sx={{ mt: 3, borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6">🚨 Notifications</Typography>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>
          <Collapse in={open}>
            <Box mt={2}>
              {notifications.map((n, i) => (
                <Alert key={i} severity={n.type} sx={{ mb: 1 }}>
                  {n.msg}
                </Alert>
              ))}
            </Box>
          </Collapse>
        </CardContent>
      </Card>
    </div>
  )
}

export default SP_Notification